import { render, staticRenderFns } from "./PlanSelector.vue?vue&type=template&id=1946a09e&scoped=true&"
import script from "./PlanSelector.vue?vue&type=script&lang=ts&"
export * from "./PlanSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PlanSelector.vue?vue&type=style&index=0&id=1946a09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946a09e",
  null
  
)

export default component.exports